<template>
	<nk-pagination :pages="context.seiten" />
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

export default {
	name: 'NkTemplatePagination',
	mixins: [TemplatesDefault],
};
</script>
